import name from './name'
export default [
    {
        path: '/Login',
        name: name.login,
        meta: {
            title: '用户登录'
        },
        component: () => import('../pages/Login')
    },
    {
        path: '/contentManage/course',
        name: name.course,
        meta: {
            title: '课程管理'
        },
        component: () => import('../pages/ContentManage/Course')
    },
    {
        path: '/contentManage/courseAdd',
        name: name.courseAdd,
        meta: {
            title: '课程新增'
        },
        component: () => import('../pages/ContentManage/CourseAdd')
    },
    {
        path: '/contentManage/courseDetail',
        name: name.courseDetail,
        meta: {
            title: '课程详情'
        },
        component: () => import('../pages/ContentManage/CourseDetail')
    },
    {
        path: '/contentManage/courseModify',
        name: name.courseModify,
        meta: {
            title: '课程更新'
        },
        component: () => import('../pages/ContentManage/CourseModify')
    },
    {
        path: '/contentManage/buy',
        name: name.buy,
        meta: {
            title: '订单管理'
        },
        component: () => import('../pages/ContentManage/Buy')
    },
    {
        path: '/contentManage/buyDetail',
        name: name.buyDetail,
        meta: {
            title: '订单详情'
        },
        component: () => import('../pages/ContentManage/BuyDetail')
    },
    {
        path: '/contentManage/seller',
        name: name.seller,
        meta: {
            title: '分销查询'
        },
        component: () => import('../pages/ContentManage/Seller')
    },
    {
        path: '/contentManage/cash',
        name: name.cash,
        meta: {
            title: '提现记录'
        },
        component: () => import('../pages/ContentManage/Cash')
    },
    {
        path: '/contentManage/buyModify',
        name: name.buyModify,
        meta: {
            title: '订单修改'
        },
        component: () => import('../pages/ContentManage/BuyModify')
    },
    {
        path: '/contentManage/User',
        name: name.user,
        meta: {
            title: '会员管理'
        },
        component: () => import('../pages/ContentManage/User')
    },
    {
        path: '/contentManage/UserDetail',
        name: name.userDetail,
        meta: {
            title: '会员详情'
        },
        component: () => import('../pages/ContentManage/UserDetail')
    },
    {
        path: '/contentManage/UserRefund',
        name: name.userRefund,
        meta: {
            title: '会员退款'
        },
        component: () => import('@pages/ContentManage/UserRefund/index')
    },
    {
        path: '/contentManage/UserNotice',
        name: name.userNotice,
        meta: {
            title: '会员通知'
        },
        component: () => import('@pages/ContentManage/UserNotice/index')
    },
    {
        path: '/contentManage/UserReceipt',
        name: name.userReceipt,
        meta: {
            title: '会员发票'
        },
        component: () => import('@pages/ContentManage/UserReceipt/index')
    },
    {
        path: '/contentManage/Receipt',
        name: name.receipt,
        meta: {
            title: '发票中心'
        },
        component: () => import('@pages/ContentManage/Receipt/index')
    },
    {
        path: '/contentManage/UserVip',
        name: name.userVip,
        meta: {
            title: '开通VIP'
        },
        component: () => import('@pages/ContentManage/UserVip/index')
    },
    {
        path: '/contentManage/Suggest',
        name: name.suggest,
        meta: {
            title: '意见反馈'
        },
        component: () => import('../pages/ContentManage/Suggest')
    },
    {
        path: '/contentManage/SuggestDetail',
        name: name.suggestDetail,
        meta: {
            title: '意见详情'
        },
        component: () => import('../pages/ContentManage/SuggestDetail')
    },
    {
        path: '/contentManage/TopNoticeSetting',
        name: name.topNoticeSetting,
        meta: {
            title: '通知栏'
        },
        component: () => import('../pages/ContentManage/TopNoticeSetting')
    },
    {
        path: '/contentManage/TopBannerSetting',
        name: name.topBannerSetting,
        meta: {
            title: '轮播图'
        },
        component: () => import('../pages/ContentManage/TopBannerSetting')
    },
    {
        path: '/contentManage/MidAdSetting',
        name: name.midAdSetting,
        meta: {
            title: '广告位'
        },
        component: () => import('../pages/ContentManage/MidAdSetting')
    },
    {
        path: '/contentManage/Tools',
        name: name.tools,
        meta: {
            title: '小工具'
        },
        component: () => import('../pages/ContentManage/Tools')
    },
    {
        path: '/contentManage/Password',
        name: name.password,
        meta: {
            title: '修改密码'
        },
        component: () => import('../pages/ContentManage/Password')
    }
    
]